import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import MainHeader from './components/MainHeader/MainHeader';
import './header.scss';

const Header = () => {
    const { allContentfulTemplate } = useStaticQuery(graphql`
        query GET_CAD_HEADER_CONTENT {
            allContentfulTemplate(filter: { nombre: { eq: "Header CAD" } }) {
                nodes {
                    span
                    url
                    image {
                        title
                        file {
                            url
                        }
                    }
                    referencias {
                        span
                        placeholder
                        image {
                            title
                            file {
                                url
                            }
                        }
                    }
                }
            }
        }
    `);

    return (
        <header className="m-header">
            <MainHeader dataHeader={allContentfulTemplate} />
        </header>
    );
};

export default Header;
